import React from 'react';

export default function SVGError(): JSX.Element {
  return (
    <svg
      width="46"
      height="46"
      viewBox="0 0 46 46"
      fill="none"
      className="text-primary stroke-current fill-current"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_7427_219863)">
        <path
          d="M25.2008 4.24627L42.7503 36.8141C43.6478 38.4797 42.4415 40.5 40.5495 40.5H5.45051C3.55848 40.5 2.35217 38.4797 3.2497 36.8141L20.7992 4.24627C21.7433 2.49418 24.2567 2.49418 25.2008 4.24627Z"
          strokeWidth="3"
          fill="transparent"
        />
        <path
          d="M23 27C22.9524 27 22.5359 19.8058 22.4105 17.6214C22.3911 17.2827 22.6607 17 23 17C23.3393 17 23.6089 17.2827 23.5895 17.6214C23.4641 19.8058 23.0476 27 23 27Z"
          strokeWidth="4"
          strokeLinecap="round"
        />
      </g>
      <circle cx="23" cy="33" r="2" />
      <defs>
        <clipPath id="clip0_7427_219863">
          <rect width="46" height="46" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
